export type ChatNode = {
  id: string,
  title: string,
  nodeType: "text" | 'article',
  answers: {text: string}[],
  labels: {text: string}[],
  edgeLabels: string[],
  nextNodes: {id: string}[],
  nextNode?: {id: string}
};

export function getDialogNodes(dialogId: string): string {
  return `
    query ChatNodes {
      allChatNodes(
        first: 99,
        filter: {
          dialogReference:{
            eq:"${dialogId}"
          }
        }
      ) {
        id,
        title,
        nodeType,
        answers {
          ... on SingleLineTextRecord { text }
        },
        labels {
          ... on SingleLineTextRecord { text }
        },        
        nextNodes {
          ... on ChatNodeRecord { id }
        },
        nextNode { id }    
      }
    }   
  `;
}